import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';
import pages, { type Card, type Page } from '.';

describe('Company + Review Page Template Config', () => {
  it('exports two pages', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(2);
  });

  describe('Company Page Template', () => {
    const companyPage = pages.find(p => p.route === PAGE_ROUTES.company) as Page;

    it('has correct route', () => {
      expect(companyPage.route).toBe(PAGE_ROUTES.company);
    });

    it('contains cards array', () => {
      expect(Array.isArray(companyPage.cards)).toBe(true);
      expect(companyPage.cards!.length).toBeGreaterThan(0);
    });

    it('contains company card', () => {
      const companyCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.company
      ) as Card;
      expect(companyCard).toBeDefined();
      expect(companyCard.fields!.length).toBe(2);
    });

    it('contains soldTo card with errorMustContain', () => {
      const soldToCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.soldTo
      ) as Card;
      expect(soldToCard.errorMustContain).toBe('address');
      expect(soldToCard.fields!.length).toBe(3);
    });

    it('deliveryDetails card has correct fieldWrapper', () => {
      const deliveryDetailsCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.deliveryDetails
      ) as Card;
      expect(deliveryDetailsCard.fieldWrapper).toContain('[0]');
    });

    it('coa card is required and has sameAsFields', () => {
      const coaCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.coa
      ) as Card;
      expect(coaCard.required).toBe(true);
      expect(Array.isArray(coaCard.sameAsFields)).toBe(true);
      expect(coaCard.sameAsFields!.length).toBeGreaterThan(0);
    });

    it('packingList card is required', () => {
      const packingListCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.packingList
      ) as Card;
      expect(packingListCard.required).toBe(true);
    });

    it('orderConfirmation card has multiple sameAsFields', () => {
      const orderCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.orderConfirmation
      ) as Card;
      expect(orderCard.required).toBe(true);
      expect(orderCard.sameAsFields!.length).toBeGreaterThan(1);
    });

    it('contains additionalAttachment card', () => {
      const attachmentCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;
      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields).toHaveLength(1);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = companyPage.cards!.find(
        (c: Card) => c.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;
      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });

  describe('Review Page Template', () => {
    const reviewPage = pages.find(p => p.route === PAGE_ROUTES.review) as Page;

    it('has correct route', () => {
      expect(reviewPage.route).toBe(PAGE_ROUTES.review);
    });

    it('contains accordions', () => {
      expect(Array.isArray(reviewPage.accordions)).toBe(true);
      expect(reviewPage.accordions).toHaveLength(1);
    });

    it('accordion contains company cards', () => {
      const accordion = reviewPage.accordions![0];
      expect(accordion.title).toBe('tabTitles.company');
      expect(Array.isArray(accordion.cards)).toBe(true);
      expect(accordion.cards.length).toBeGreaterThan(0);
    });
  });
});
